import CustomModal from "../CustomModal/CustomModal";
import CustomButton from "../CustomButton/Button";
import CancelButton from "../CustomButton/CancelButton";

const RejectDealModal = ({ open, onCancel, onReject, loading, reason, onReasonChange }) => {
    return (
        <CustomModal
            title="Reject Deal"
            open={open}
            onCancel={onCancel}
            maskClosable={!loading}
            closable={!loading}
            content={(
                <div>
                    <label style={{ display: "block", marginBottom: 8, fontWeight: 500 }}>
                        Reason for reject <span style={{ color: "#ef4444" }}>*</span>
                    </label>
                    <textarea
                        rows={4}
                        value={reason}
                        maxLength={500}
                        onChange={(e) => onReasonChange(e.target.value)}
                        placeholder="Enter reason for rejection"
                        style={{ width: "100%", resize: "vertical", padding: "10px", borderRadius: "6px", border: "1px solid #d9d9d9" }}
                        disabled={loading}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "4px" }}>
                        <span style={{ fontSize: "12px", color: reason.length >= 500 ? "#9ca3af" : "#6b7280" }}>
                            {reason.length}/500
                        </span>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 16 }}>
                        <CancelButton onClick={onCancel} disabled={loading} />
                        <CustomButton type="primary" loading={loading} onClick={onReject}>
                            Reject
                        </CustomButton>
                    </div>
                </div>
            )}
        />
    );
};

export default RejectDealModal;
